var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/feed-filtering/feed-carousel.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import classNames from 'clsx';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { replaceHomeTimeline } from 'soapbox/actions/timelines';
import { useAppDispatch, useAppSelector, useDimensions } from 'soapbox/hooks';
import useCarouselAvatars from 'soapbox/queries/carousels';
import { Card, HStack, Icon, Stack, Text } from '../../components/ui';
import PlaceholderAvatar from '../placeholder/components/placeholder-avatar';

const CarouselItem = _ref => {
  let {
    avatar
  } = _ref;
  const dispatch = useAppDispatch();
  const selectedAccountId = useAppSelector(state => {
    var _state$timelines$get;

    return (_state$timelines$get = state.timelines.get('home')) === null || _state$timelines$get === void 0 ? void 0 : _state$timelines$get.feedAccountId;
  });
  const isSelected = avatar.account_id === selectedAccountId;
  const [isFetching, setLoading] = useState(false);

  const handleClick = () => {
    if (isFetching) {
      return;
    }

    setLoading(true);

    if (isSelected) {
      dispatch(replaceHomeTimeline(null, {
        maxId: null
      }, () => setLoading(false)));
    } else {
      dispatch(replaceHomeTimeline(avatar.account_id, {
        maxId: null
      }, () => setLoading(false)));
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    "aria-disabled": isFetching,
    onClick: handleClick,
    className: "cursor-pointer",
    role: "filter-feed-by-user",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    className: "w-16 h-auto",
    space: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "block mx-auto relative w-14 h-14 rounded-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }, isSelected && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-primary-600 bg-opacity-50 rounded-full flex items-center justify-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/x.svg'),
    className: "text-white h-6 w-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement("img", {
    src: avatar.account_avatar,
    className: classNames({
      'w-14 h-14 min-w-[56px] rounded-full ring-2 ring-offset-4 dark:ring-offset-primary-900': true,
      'ring-transparent': !isSelected,
      'ring-primary-600': isSelected
    }),
    alt: avatar.acct,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    truncate: true,
    align: "center",
    className: "leading-3 pb-0.5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 9
    }
  }, avatar.acct)));
};

const FeedCarousel = () => {
  const {
    data: avatars,
    isFetching,
    isError
  } = useCarouselAvatars();
  const [cardRef, setCardRef, {
    width
  }] = useDimensions();
  const [pageSize, setPageSize] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const numberOfPages = Math.ceil(avatars.length / pageSize);
  const widthPerAvatar = ((cardRef === null || cardRef === void 0 ? void 0 : cardRef.scrollWidth) || 0) / avatars.length;
  const hasNextPage = currentPage < numberOfPages && numberOfPages > 1;
  const hasPrevPage = currentPage > 1 && numberOfPages > 1;

  const handleNextPage = () => setCurrentPage(prevPage => prevPage + 1);

  const handlePrevPage = () => setCurrentPage(prevPage => prevPage - 1);

  useEffect(() => {
    if (width) {
      setPageSize(Math.round(width / widthPerAvatar));
    }
  }, [width, widthPerAvatar]);

  if (isError) {
    return /*#__PURE__*/React.createElement(Card, {
      variant: "rounded",
      size: "lg",
      "data-testid": "feed-carousel-error",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Text, {
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 87,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "common.error",
      defaultMessage: "Something isn't right. Try reloading the page.",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 11
      }
    })));
  }

  if (avatars.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Card, {
    variant: "rounded",
    size: "lg",
    className: "relative",
    "data-testid": "feed-carousel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 7
    }
  }, hasPrevPage && /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "z-10 absolute left-5 top-1/2 -mt-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("button", {
    "data-testid": "prev-page",
    onClick: handlePrevPage,
    className: "bg-white/50 dark:bg-gray-900/50 backdrop-blur rounded-full h-8 w-8 flex items-center justify-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/chevron-left.svg'),
    className: "text-black dark:text-white h-6 w-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 8,
    className: "z-0 flex transition-all duration-200 ease-linear scroll",
    style: {
      transform: "translateX(-".concat((currentPage - 1) * 100, "%)")
    },
    ref: setCardRef,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 9
    }
  }, isFetching ? new Array(pageSize).fill(0).map((_, idx) => /*#__PURE__*/React.createElement("div", {
    className: "w-16 text-center",
    key: idx,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(PlaceholderAvatar, {
    size: 56,
    withText: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 17
    }
  }))) : avatars.map(avatar => /*#__PURE__*/React.createElement(CarouselItem, {
    key: avatar.account_id,
    avatar: avatar,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 15
    }
  }))), hasNextPage && /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "z-10 absolute right-5 top-1/2 -mt-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("button", {
    "data-testid": "next-page",
    onClick: handleNextPage,
    className: "bg-white/50 dark:bg-gray-900/50 backdrop-blur rounded-full h-8 w-8 flex items-center justify-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/chevron-right.svg'),
    className: "text-black dark:text-white h-6 w-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 17
    }
  }))))));
};

export default FeedCarousel;